
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    // Set page title and meta description
    document.title = 'Tyson\'s Lawn Care Services - Professional Lawn Maintenance';
    
    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Tyson's Lawn Care Services",
      "description": "Professional lawn maintenance services including mowing, edging, blowing, and bush trimming. Quality work with customer rewards program.",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "telephone": "(470) 530-5451",
      "email": "tysonphongle@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Lawrenceville",
        "addressRegion": "GA",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "33.9562",
        "longitude": "-83.9879"
      },
      "openingHours": [
        "We 09:00-18:00",
        "Fr 09:00-18:00"
      ],
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "33.9562",
          "longitude": "-83.9879"
        },
        "geoRadius": "25000"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Lawn Care Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Lawn Mowing",
              "description": "Professional lawn mowing service"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Edging",
              "description": "Precise lawn edging service"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Bush Trimming",
              "description": "Professional bush and shrub trimming"
            }
          }
        ]
      },
      "priceRange": "$$",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "127"
      }
    });
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
